import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
  inject,
  OnInit,
  OnDestroy,
} from "@angular/core";
import { Subject, fromEvent, takeUntil } from "rxjs";
import { debounceTime, throttleTime } from "rxjs/operators";
import { ScreenSizeService } from "./screen-size.service";

@Directive({
  selector: "[fadeOnScroll]",
  standalone: true,
})
export class FadeOnScrollDirective implements OnInit, OnDestroy {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);
  private readonly navbarHeight = 40; // Height of your navbar
  private readonly threshold = 60; // Distance to start fading
  private destroy$ = new Subject<void>();

  @Input() fadeOnScroll: boolean = false;
  screenSizeService = inject(ScreenSizeService);

  constructor() {
    // Add transition style on initialization
    this.renderer.setStyle(
      this.el.nativeElement,
      "transition",
      "opacity 0.02s ease-in-out",
    );
  }

  ngOnInit() {
    if (!this.screenSizeService.isBrowser) return;

    // Set up debounced scroll listener
    fromEvent(window, "scroll")
      .pipe(
        throttleTime(16), // Approximately 60fps
        takeUntil(this.destroy$),
      )
      .subscribe(() => this.updateOpacity());

    // Initial update to set correct opacity on load
    this.updateOpacity();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateOpacity() {
    if (!this.fadeOnScroll) return;
    const rect = this.el.nativeElement.getBoundingClientRect();
    let opacity = 1;

    // Only fade when element approaches the navbar
    if (rect.top < this.navbarHeight + this.threshold) {
      opacity = Math.max(0, (rect.top - this.navbarHeight) / this.threshold);
    }

    this.renderer.setStyle(this.el.nativeElement, "opacity", opacity);
  }
}
